import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getToolBySlug } from '@/data/tools';

interface RelatedToolsProps {
  currentSlug: string;
  relatedSlugs: string[];
}

const RelatedTools = ({ currentSlug, relatedSlugs }: RelatedToolsProps) => {
  const relatedTools = relatedSlugs
    .filter(slug => slug !== currentSlug)
    .map(slug => getToolBySlug(slug))
    .filter(Boolean);

  if (relatedTools.length === 0) return null;

  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-foreground text-center mb-8">
          Herramientas relacionadas
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {relatedTools.map(tool => (
            <Link
              key={tool!.slug}
              to={`/herramientas/${tool!.slug}`}
              className="group block p-6 rounded-xl border border-border bg-card hover:shadow-md hover:border-primary/30 transition-all duration-200"
            >
              <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors mb-2">
                {tool!.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-3">
                {tool!.subtitle}
              </p>
              <span className="inline-flex items-center text-sm text-primary font-medium">
                Usar herramienta
                <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedTools;
